import { render, staticRenderFns } from "./OtherBox.vue?vue&type=template&id=bedd8880&scoped=true&"
import script from "./OtherBox.vue?vue&type=script&lang=ts&"
export * from "./OtherBox.vue?vue&type=script&lang=ts&"
import style0 from "./OtherBox.vue?vue&type=style&index=0&id=bedd8880&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bedd8880",
  null
  
)

export default component.exports